import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { FavouriteCollectionForm } from "./favourite-collection-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";

export const FavouriteCollectionDialog = (props) => {
  const { t } = useTranslation();
  const {
    onClose,
    open = false,
    onSubmit,
    item,
    isFromFavouritesButton = false,
  } = props;

  return (
    <Dialog fullWidth maxWidth="sm" onClose={onClose} open={open}>
      <Stack
        direction="row"
        spacing={3}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          pt: 2
        }}>
        {item ? (
          <Typography variant="h6">
            {t("favourites.editFavouriteCollection")}: {item?.name}
          </Typography>
        ) : (
          <Typography variant="h6">
            {t("favourites.addNewCollection")}
          </Typography>
        )}
        <IconButton color="inherit" onClick={onClose}>
          <SvgIcon>
            <FontAwesomeIcon icon={faXmark} />
          </SvgIcon>
        </IconButton>
      </Stack>
      <DialogContent>
        <Stack spacing={2}>
          <FavouriteCollectionForm
            onSubmit={onSubmit}
            item={item}
            isFromFavouritesButton={isFromFavouritesButton}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

FavouriteCollectionDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onSubmit: PropTypes.func,
  item: PropTypes.object,
  isFromFavouritesButton: PropTypes.bool,
};
